import { Checkbox, FormControlLabel } from "@material-ui/core";
import React from "react";
import { dateFormatter } from "../../../components/tables/table";

const SupplierContent = ({ supplier }) => {
	if (!supplier) return <></>;
	return (
		<>
			<div className="row d-flex align-items-center">
				<div className="col-md-4">
					<h5>Nombre Comercial</h5>
					<p>{supplier?.nombre}</p>
				</div>
				<div className="col-md-4">
					<h5>Razón Social</h5>
					<p>{supplier?.razon_social || "---"}</p>
				</div>
				<div className="col-md-4">
					<h5>NIF</h5>
					<p>{supplier?.nif || "---"}</p>
				</div>
			</div>
			<div className="row d-flex align-items-center">
				<div className="col-md-4">
					<h5>Tipo de proveedor</h5>
					<p>{supplier?.tipo_proveedor?.descripcion || "---"}</p>
				</div>
				<div className="col-md-4">
					<h5>Dirección</h5>
					<p>{supplier?.direccion || "---"}</p>
				</div>
				<div className="col-md-4">
					<h5>Código Postal</h5>
					<p>{supplier?.codigo_postal || "---"}</p>
				</div>
			</div>
			<div className="row d-flex align-items-center">
				<div className="col-md-4">
					<h5>Población</h5>
					<p>{supplier?.poblacion || "---"}</p>
				</div>
				<div className="col-md-4">
					<h5>Província</h5>
					<p>{supplier?.provincia || "---"}</p>
				</div>
				<div className="col-md-4">
					<h5>País</h5>
					<p>{supplier?.pais || "---"}</p>
				</div>
			</div>
			<div className="row d-flex align-items-center">
				<div className="col-md-4">
					<h5>Web</h5>
					<p>{supplier?.web || "---"}</p>
				</div>
				<div className="col-md-4">
					<h5>Contacto Nombre</h5>
					<p>{supplier?.contacto_nombre || "---"}</p>
				</div>
				<div className="col-md-4">
					<h5>Contacto Email</h5>
					<p>{supplier?.contacto_email || "---"}</p>
				</div>
			</div>
			<div className="row d-flex align-items-center">
				<div className="col-md-4">
					<h5>Contacto Teléfono Fijo</h5>
					<p>{supplier?.contacto_telefono_fijo || "---"}</p>
				</div>
				<div className="col-md-4">
					<h5>Contacto Teléfono Móvil</h5>
					<p>{supplier?.contacto_telefono_movil || "---"}</p>
				</div>
				<div className="col-md-4">
					<h5>Contacto Fax</h5>
					<p>{supplier?.contacto_fax || "---"}</p>
				</div>
			</div>
			<div className="row d-flex align-items-center">
				<div className="col-md-4">
					<FormControlLabel
						control={
							<Checkbox
								checked={supplier.activo}
								name="checkActive"
								disabled
							/>
						}
						label="Activo"
					/>
				</div>
				<div className="col-md-4">
					<h5>Fecha Alta</h5>
					<p>{dateFormatter(supplier?.fecha_alta) + "h"}</p>
				</div>
			</div>
		</>
	);
};

export default SupplierContent;
